import React from 'react';
import Lottie from "lottie-react";
import wavingHand from "../assets/waving-hand.json";
import robotAnimation from "../assets/robot-animation.json";

function Hero() {
  return (
    <section
      id="home"
      data-aos="fade-down" // ✅ scroll animation
      className="min-h-screen flex flex-col md:flex-row justify-between items-center px-6 md:px-16 bg-gradient-to-b from-[#0f172a] via-[#1e293b] to-[#0f172a] text-white relative"
    >
      {/* Text Section */}
      <div className="text-center md:text-left py-16" data-aos="fade-right">
        <h2 className="text-4xl md:text-5xl font-bold mb-2 flex items-center gap-2">
          Hello Everyone!
          <Lottie animationData={wavingHand} loop={true} className="w-14 h-14" />
        </h2>

        <h1 className="text-5xl md:text-6xl font-bold mb-4">
          I&apos;M{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-purple-500 to-pink-500">
            KARMADEEP
          </span>
        </h1>
        <p className="text-xl text-purple-300 font-mono animate-pulse">
          Software Developer
        </p>
      </div>

      {/* Lottie Robot Animation */}
      <div
        className="md:w-1/2 flex justify-center items-center py-8 md:py-0"
        data-aos="zoom-in"
      >
        <Lottie animationData={robotAnimation} loop={true} className="w-72 md:w-96" />
      </div>

      {/* Floating Button */}
      <div
        className="absolute bottom-8 right-6 md:right-16"
        data-aos="fade-up"
        data-aos-delay="400"
      >
        <div className="bg-blue-900 text-white px-5 py-3 rounded-xl shadow-lg border border-blue-400">
          Don't Forget to give me feedback at Contact Section.
        </div>
      </div>
    </section>
  );
}

export default Hero;
